module.exports = __webpack_public_path__ + "img/vg.ea35ce59.svg";